import find from "lodash/find";

const getParentChapterId = (state, ownProps) => {
  const chapterEntities = state.story.chapters;
  const entities = state.story.entities;
  const chapterId = ownProps.chapterId;

  const matchingChapterEntity = find(chapterEntities, { id: chapterId });
  const matchingChapter =
    entities[matchingChapterEntity.schema][matchingChapterEntity.id];

  return matchingChapter.parent;
};

export default getParentChapterId;
